"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RADMovementT = exports.MedicareModelT = exports.MedicareModelConcreteT = exports.BondT = exports.MedicareModelSupportedRatioT = exports.MedicareModelRespiteAllocationT = exports.MedicareModelCareRecipientT = exports.MedicareModelCarePaymentMedicareT = exports.MedicareFileT = exports.AccountTypeT = exports.AmountTypeT = exports.FeeT = exports.FeeValueT = exports.ImportFileT = exports.EmailedInvoiceT = exports.InvoiceT = exports.IgnoredAmountT = exports.IgnoredAmountsPackedT = exports.JournalAccountLocationT = exports.JournalAccountT = exports.BedT = exports.IncidentalT = exports.BatchT = exports.BatchItemT = exports.BatchItemChequeInfoT = exports.DownloadedTransactionT = exports.TransactionT = exports.MovementT = exports.MovementImplicitT = exports.MovementDrawdownT = exports.MovementFeeT = exports.HistoricalMTFNodeT = exports.HistoricalMTFCalculatedT = exports.HistoricalMTFT = exports.HomeCareBudgetT = exports.EmailedStatementT = exports.ResidentNoteT = exports.ResidentLeaveT = exports.ResidentContactT = exports.ResidentBankT = exports.ResidentAgreementStatusT = exports.ResidentAgreementT = exports.ResidentAgreementDetailsT = exports.ResidentAgreementVariationT = exports.AgreementTemplatesT = exports.ResidentAdmissionT = exports.ResidentAccountT = exports.ResidentInWaitingT = exports.ResidentInWaitingNoteT = exports.ResidentT = void 0;
exports.staticProdaServicesT = exports.staticHCPackageLevelsT = exports.staticHCServiceCategoryT = exports.staticSalutationT = exports.staticInterestAndAssetsT = exports.staticRespiteTypeT = exports.staticNoteTypeT = exports.staticLeaveReasonT = exports.staticImportFileTypeT = exports.staticILUFeeFrequencyT = exports.staticDischargeReasonT = exports.staticBCTTypeT = exports.staticBRCTypeT = exports.staticBankBranchT = exports.staticANACCClassT = exports.staticIDCodeNameT = exports.staticCodeNameT = exports.staticIDNameT = exports.AccountTypeStaticT = exports.BillingSystemValuesT = exports.BankT = exports.BillingMetaT = exports.DDExemptT = exports.CDCAccountRuleT = exports.CDCLocationGroupT = exports.CDCServiceTypeT = exports.CDCDateTimeRangeT = exports.CDCChargeSequenceT = exports.CDCChargeGroupT = exports.CDCChargeCriteriaT = exports.CDCServiceT = exports.HCIncidentalChargeT = exports.RosterClientGroupT = exports.RosterPeriodT = exports.PeriodStepsCDCT = exports.PeriodStepCDCT = exports.PeriodStepsT = exports.BillingPeriodFortnightlyT = exports.BillingPeriodT = exports.FacilityLocationT = exports.FacilityStatementLabelT = exports.FacilityStatementCommentT = exports.FacilityContactT = exports.FacilityBankT = exports.FacilityT = exports.RACSViabilityCategoryT = exports.RACSRespiteAllocationT = exports.RACST = exports.BranchCustomT = exports.RADT = void 0;
exports.ErrorsListT = exports.ErrorItemT = exports.BillingErrorT = exports.HydrationPayloadT = exports.agentThreadHydration = exports.HydrationSpecT = exports.HydrationSpecItemT = exports.HydrationActionType = exports.hydrationNodes = exports.HydrationNodeT = exports.BatchPackageT = exports.BillingDataModelT = exports.AgentMetaT = exports.TaskThreadsByTaskT = exports.TaskDetailsT = exports.TaskListItemT = exports.BillingStaticT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
const types_agents_1 = require("./types-agents");
const types_llm_2_1 = require("./types-llm-2");
const types_reports_1 = require("./types-reports");
exports.ResidentT = tBox.Object({
    ID: tBox.Number(),
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    Surname: tBox.String(),
    FGiven: tBox.String(),
    SGiven: tBox.String(),
    PrefName: (0, meta_types_1.MaybeT)(tBox.String()),
    Address: (0, meta_types_1.MaybeT)(tBox.Number()),
    Contact: tBox.Number(),
    Gender: (0, meta_types_1.MaybeT)(tBox.String()),
    MaritalStatus: (0, meta_types_1.MaybeT)(tBox.String()),
    StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    DOB: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    PensionNo: (0, meta_types_1.MaybeT)(tBox.String()),
    PensionExpiry: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    DepartmentID: (0, meta_types_1.MaybeT)(tBox.String()),
    CareRecipientID: (0, meta_types_1.MaybeT)(tBox.String()),
    MedicalRecNo: (0, meta_types_1.MaybeT)(tBox.String()),
    RegisterNo: (0, meta_types_1.MaybeT)(tBox.String()),
    Religion: (0, meta_types_1.MaybeT)(tBox.String()),
    SelfBilling: meta_types_1.tBoolT,
    PreACFI: meta_types_1.tBoolT,
    PreLLLB: meta_types_1.tBoolT,
    PreANACC: meta_types_1.tBoolT,
    Nov25HCPGrandfather: meta_types_1.tBoolT,
    Program: (0, meta_types_1.MaybeT)(tBox.Number()),
    RosterArea: (0, meta_types_1.MaybeT)(tBox.Number()),
    RosterGroup: (0, meta_types_1.MaybeT)(tBox.Number()),
    RosterNote: tBox.String(),
    MigrationKey: (0, meta_types_1.MaybeT)(tBox.String()),
    PrefSurname: (0, meta_types_1.MaybeT)(tBox.String()),
    MedicareNo: (0, meta_types_1.MaybeT)(tBox.String()),
    MedicareExpiry: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    ReceivesInvoices: tBox.Number(),
    AddressPostal: (0, meta_types_1.MaybeT)(tBox.Number()),
    Mobility: (0, meta_types_1.MaybeT)(tBox.String()),
    OriginalAdmissionDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    OriginalFacilityName: (0, meta_types_1.MaybeT)(tBox.String()),
    FullNamePreferred: tBox.String(),
    FullName: tBox.String(),
    Active: tBox.Boolean(),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.ResidentInWaitingNoteT = tBox.Object({
    ID: tBox.Number(),
    ResidentInWaiting: tBox.Number(),
    Timestamp: (0, dates_1.DateTimeObjT)(),
    Note: tBox.String(),
});
exports.ResidentInWaitingT = tBox.Object({
    ID: tBox.Number(),
    FullName: tBox.String(),
    Surname: tBox.String(),
    FGiven: tBox.String(),
    DOB: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Location: tBox.Number(),
    Contact: tBox.Number(),
    Address: (0, meta_types_1.MaybeT)(tBox.Number()),
    PensionNo: (0, meta_types_1.MaybeT)(tBox.String()),
    PensionExpiry: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    MedicareNo: (0, meta_types_1.MaybeT)(tBox.String()),
    MedicareExpiry: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    ContactName: (0, meta_types_1.MaybeT)(tBox.String()),
    ContactContact: (0, meta_types_1.MaybeT)(tBox.Number()),
    Notes: tBox.Array(exports.ResidentInWaitingNoteT),
    Admitted: meta_types_1.tBoolT,
});
exports.ResidentAccountT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    Type: tBox.Number(),
    BPayCRN: (0, meta_types_1.MaybeT)(tBox.String()),
    FacilityBank: (0, meta_types_1.MaybeT)(tBox.Number()),
    CloseDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    Balance: tBox.Number(),
    LatestPeriod: (0, meta_types_1.MaybeT)(tBox.Number()),
    TransactionCount: tBox.Number(),
    TransactionsThisPeriod: tBox.Boolean(),
});
exports.ResidentAdmissionT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    Facility: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    DischargeReason: (0, meta_types_1.MaybeT)(tBox.String()),
    PreAdmit: meta_types_1.tBoolT,
    Respite: (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 1 })),
});
exports.AgreementTemplatesT = tBox.Object({
    ID: tBox.Number(),
    Title: tBox.String(),
    TextLines: tBox.String(),
});
exports.ResidentAgreementVariationT = tBox.Object({
    ID: tBox.Number(),
    Agreement: tBox.Number(),
    EffectiveDate: (0, dates_1.DateObjT)(),
    FileSnapshot: (0, meta_types_1.MaybeT)(tBox.String()),
    Signed: meta_types_1.tBoolT,
    SignatureFile: (0, meta_types_1.MaybeT)(tBox.String()),
    Deleted: meta_types_1.tBoolT,
    Details: tBox.Array(tBox.String()),
});
const DetailsMaybeNumberT = tBox.Union([tBox.String(), tBox.Number()]);
const SahPaymentMethodT = tBox.Union([
    tBox.Literal('DirectDebit'),
    tBox.Literal('CentrePay'),
    tBox.Literal('Other'),
]);
exports.ResidentAgreementDetailsT = tBox.Partial(tBox.Object({
    ApprovalExpiry: tBox.Union([tBox.Literal(''), meta_types_1.tDateT]),
    BookingFeeAccomEntry: tBox.String(),
    HasAdditionalServices: tBox.Boolean(),
    AdditionalServiceFee: tBox.String(),
    AdditionalServiceGSTType: (0, meta_types_1.MaybeT)(tBox.Union([
        tBox.Literal(-1),
        tBox.Literal(0),
        tBox.Literal(1),
        tBox.Literal(2),
    ])),
    AdditionalServicePeriodMultiple: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)])),
    AdditionalServicePeriodSingle: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)])),
    UsePartHNotice: tBox.Boolean(),
    PriorNoticePeriod: DetailsMaybeNumberT,
    EntryCareFees: tBox.String(),
    EntryAdditionalServiceFee: tBox.String(),
    EntryFeePrepaid: tBox.String(),
    HasCaveatableInterest: tBox.Boolean(),
    RegisteredProprietor: tBox.String(),
    CaveatablePropertyAddress: tBox.String(),
    CaveatableTitle: tBox.String(),
    FinancialInfoProvided: tBox.Boolean(),
    CompPaymentFee: DetailsMaybeNumberT,
    RemoteArea: DetailsMaybeNumberT,
    CDCTransfer: tBox.Boolean(),
    CareManagerName: tBox.String(),
    CareManagerPhone: tBox.String(),
    DementiaSupp: tBox.Number(),
    VeteransSupp: tBox.Number(),
    OxygenSupp: tBox.Number(),
    EnteralSupp: tBox.Number(),
    HardshipSupp: DetailsMaybeNumberT,
    ViabilitySupp: tBox.Number(),
    TopUpSupp: tBox.Number(),
    BudgetedServiceCharges: DetailsMaybeNumberT,
    ExtraConditions: tBox.String(),
    BudgetID: (0, meta_types_1.MaybeT)(tBox.Number()),
    ActualRAD: DetailsMaybeNumberT,
    AgreedPayment: (0, meta_types_1.MaybeT)(DetailsMaybeNumberT),
    IsRAC: tBox.Boolean(),
    AccommodationCharge: DetailsMaybeNumberT,
    MPIR: DetailsMaybeNumberT,
    PublishedPrice: (0, meta_types_1.MaybeT)(DetailsMaybeNumberT),
    AccomFeeType: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)])),
    PaymentMethod: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)])),
    SaHPaymentMethod: (0, meta_types_1.MaybeT)(SahPaymentMethodT),
    SaHPaymentMethodDescription: (0, meta_types_1.MaybeT)(tBox.String()),
    BRCType: tBox.Number(),
    HasHCBasicFee: tBox.Boolean(),
    MeansTestFee: DetailsMaybeNumberT,
    HotelSuppContr: DetailsMaybeNumberT,
    NonClinicalContribution: DetailsMaybeNumberT,
    CleanEnergy: tBox.Boolean(),
    BedID: (0, meta_types_1.MaybeT)(tBox.Number()),
    AddressBilling: tBox.Unknown(),
    Location: tBox.Number(),
    AgreementDate: meta_types_1.tDateT,
    AdmissionPreStart: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    AdmissionPreEnd: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    RespiteType: (0, meta_types_1.MaybeT)(tBox.String()),
    AdmissionEnd: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(''), meta_types_1.tDateT])),
    MeansTestAssessed: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)])),
    PackageLevel: (0, meta_types_1.MaybeT)(tBox.Union([
        tBox.Literal('0'),
        tBox.Literal('1'),
        tBox.Literal('2'),
        tBox.Literal('3'),
        tBox.Literal('4'),
        tBox.Literal('A'),
        tBox.Literal('B'),
        tBox.Literal('C'),
        tBox.Literal('D'),
        tBox.Literal('E'),
        tBox.Literal('F'),
        tBox.Literal('G'),
        tBox.Literal('H'),
    ])),
    AccessApprovalAttached: tBox.Boolean(),
    RoomServices: (0, meta_types_1.MaybeT)(tBox.String()),
}));
exports.ResidentAgreementT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    Signed: meta_types_1.tBoolT,
    SignatureFile: (0, meta_types_1.MaybeT)(tBox.String()),
    Deleted: meta_types_1.tBoolT,
    FileSnapshot: (0, meta_types_1.MaybeT)(tBox.String()),
    Details: exports.ResidentAgreementDetailsT,
    Variations: tBox.Array(exports.ResidentAgreementVariationT),
    IsPending: tBox.Boolean(),
});
exports.ResidentAgreementStatusT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    FinalisedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Signed: tBox.Boolean(),
});
exports.ResidentBankT = tBox.Object({
    ID: tBox.Number(),
    Account: tBox.Number(),
    Bank: tBox.Number(),
    DirectDebitFixed: tBox.Number(),
    DirectDebitPercentage: tBox.Number(),
});
exports.ResidentContactT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Resident: tBox.Number(),
    Address: (0, meta_types_1.MaybeT)(tBox.Number()),
    Contact: tBox.Number(),
    Description: tBox.String(),
    DriversLicenceNo: (0, meta_types_1.MaybeT)(tBox.String()),
    CareOfGeneration: meta_types_1.tBoolT,
    Accounts: tBox.Array(tBox.Number()),
    Types: tBox.Array(tBox.Number()),
    Enabled: meta_types_1.tBoolT,
});
exports.ResidentLeaveT = tBox.Object({
    ID: tBox.Number(),
    Admission: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Reason: tBox.String(),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.ResidentNoteT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    Timestamp: (0, dates_1.DateTimeObjT)(),
    Type: (0, meta_types_1.MaybeT)(tBox.Number()),
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    Note: tBox.String(),
    Attachment: (0, meta_types_1.MaybeT)(tBox.String()),
    AttachmentMimeType: (0, meta_types_1.MaybeT)(tBox.String()),
    IsShared: meta_types_1.tBoolT,
    Deleted: meta_types_1.tBoolT,
});
exports.EmailedStatementT = tBox.Object({
    ID: tBox.Number(),
    Period: tBox.Number(),
    Account: (0, meta_types_1.MaybeT)(tBox.Number()),
    AccountType: tBox.Number(),
    Facility: tBox.Number(),
    Contact: (0, meta_types_1.MaybeT)(tBox.Number()),
    Timestamp: (0, dates_1.DateTimeObjT)(),
    Pages: tBox.Array(tBox.Number()),
    FileHash: tBox.String(),
    WasClosed: meta_types_1.tBoolT,
    Sent: meta_types_1.tBoolT,
    Delivered: meta_types_1.tBoolT,
});
exports.HomeCareBudgetT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    AccountType: tBox.Number({
        description: 'The type of account that this budget is for. DB defaults to the standard home care budget (5)',
    }),
    Data: tBox.Partial(tBox.Object({
        package: (0, meta_types_1.MaybeT)(tBox.String()),
        days: tBox.Number(),
        dementia: tBox.Boolean(),
        veterans: tBox.Boolean(),
        oxygen: tBox.Boolean(),
        viability: (0, meta_types_1.MaybeT)(tBox.Number()),
        enteral: (0, meta_types_1.MaybeT)(tBox.String()),
        pensionStatus: (0, meta_types_1.MaybeT)(tBox.String()),
        hcCopayIndependence: (0, meta_types_1.MaybeT)(tBox.Number()),
        hcCopayEverydayLiving: (0, meta_types_1.MaybeT)(tBox.Number()),
        sahIsInterim: (0, meta_types_1.MaybeT)(tBox.Boolean()),
        customFeesIncome: tBox.Array(tBox.Object({
            Fee: (0, meta_types_1.MaybeT)(tBox.Number()),
            Amount: (0, meta_types_1.MaybeT)(tBox.Number()),
        })),
        customFeesExpenses: tBox.Array(tBox.Object({
            Fee: (0, meta_types_1.MaybeT)(tBox.Number()),
            Amount: (0, meta_types_1.MaybeT)(tBox.Number()),
        })),
        miscLines: tBox.Array(tBox.Object({
            Label: (0, meta_types_1.MaybeT)(tBox.String()),
            Amount: (0, meta_types_1.MaybeT)(tBox.Number()),
        })),
        services: tBox.Array(tBox.Object({
            ServiceType: tBox.Number(),
            Frequency: tBox.Number(),
            Days: tBox.Array(tBox.Union([
                tBox.Literal(1),
                tBox.Literal(2),
                tBox.Literal(3),
                tBox.Literal(4),
                tBox.Literal(5),
                tBox.Literal(6),
                tBox.Literal(7),
            ])),
            Start: tBox.String(),
            Stop: tBox.String(),
            Employees: tBox.Number(),
            CostOverride: (0, meta_types_1.MaybeT)(tBox.Number()),
        })),
    })),
});
exports.HistoricalMTFT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    YearStart: tBox.Number(),
    Amount: tBox.Number(),
});
exports.HistoricalMTFCalculatedT = tBox.Object({
    Resident: tBox.Number(),
    YearStart: tBox.Number(),
    Amount: tBox.Number(),
});
exports.HistoricalMTFNodeT = tBox.Object({
    calculated: tBox.Array(exports.HistoricalMTFCalculatedT),
    entered: tBox.Record(tBox.Number(), exports.HistoricalMTFT),
});
exports.MovementFeeT = tBox.Object({
    Movement: tBox.Number(),
    Fee: tBox.Number(),
    Amount: (0, meta_types_1.MaybeT)(tBox.Number()),
    AmountType: (0, meta_types_1.MaybeT)(tBox.Number()),
    Explicit: meta_types_1.tBoolT,
});
exports.MovementDrawdownT = tBox.Object({
    Movement: tBox.Number(),
    Fee: tBox.Number(),
    Amount: tBox.Number(),
    Method: tBox.Number(),
});
exports.MovementImplicitT = tBox.Object({
    Start: (0, dates_1.DateObjT)(),
    End: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Fees: tBox.Array(tBox.Number()),
    LastOnAdmission: tBox.Boolean(),
});
exports.MovementT = tBox.Object({
    ID: tBox.Number(),
    Admission: tBox.Number(),
    Respite: (0, meta_types_1.MaybeT)(tBox.String()),
    Resident: tBox.Number(),
    Location: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    AdmissionEnd: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    AccommodationCharge: (0, meta_types_1.MaybeT)(tBox.Number()),
    HotelSuppContr: (0, meta_types_1.MaybeT)(tBox.Number()),
    BasicFeeAdjustment: (0, meta_types_1.MaybeT)(tBox.Number()),
    CategoryExpiry: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    CareManagementSupp: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    CleanEnergySupp: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    DementiaSupp: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
    IsFDP: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    GPFlag: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    HardshipAmount: (0, meta_types_1.MaybeT)(tBox.Number()),
    MeansTestAmount: (0, meta_types_1.MaybeT)(tBox.Number()),
    MeansTestAssessment: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    OxygenSupp: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    VeteransSupp: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    SAHIsInterim: meta_types_1.tBoolT,
    AccommodationPayment: (0, meta_types_1.MaybeT)(tBox.String()),
    BRCType: tBox.Number(),
    ConcessionType: tBox.Number(),
    Liability: tBox.String(),
    PensionStatus: tBox.String(),
    Provider: tBox.String(),
    ACFICategory_ADL: (0, meta_types_1.MaybeT)(tBox.String()),
    ACFICategory_BEH: (0, meta_types_1.MaybeT)(tBox.String()),
    ACFICategory_CHC: (0, meta_types_1.MaybeT)(tBox.String()),
    ANACCLevel: (0, meta_types_1.MaybeT)(tBox.Number()),
    Enteral: (0, meta_types_1.MaybeT)(tBox.String()),
    RCSCategory: (0, meta_types_1.MaybeT)(tBox.String()),
    HCSubsidyLevel: (0, meta_types_1.MaybeT)(tBox.String()),
    CopayIndependence: (0, meta_types_1.MaybeT)(tBox.Number()),
    CopayEverydayLiving: (0, meta_types_1.MaybeT)(tBox.Number()),
    HardshipAmountDAP: (0, meta_types_1.MaybeT)(tBox.Number()),
    BasicFeeAdjustmentSplit: meta_types_1.tBoolT,
    MMM: (0, meta_types_1.MaybeT)(tBox.Number()),
    ExtraServiceFee: (0, meta_types_1.MaybeT)(tBox.Number()),
    ILUFee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Fees: tBox.Array(exports.MovementFeeT),
    FeeAccounts: tBox.Record(tBox.Number(), tBox.Number(), {
        description: "Key is 'fee'",
    }),
    Drawdowns: tBox.Record(tBox.Number(), exports.MovementDrawdownT, {
        description: "Key is 'fee'",
    }),
    LastOnAdmission: tBox.Boolean(),
    Implicits: tBox.Record(meta_types_1.tDateT, exports.MovementImplicitT, { description: "Key is 'key'" }),
});
exports.TransactionT = tBox.Object({
    BatchItem: tBox.Number(),
    Account: (0, meta_types_1.MaybeT)(tBox.Number()),
    Amount: tBox.Number(),
    GST: tBox.Number(),
    Invoice: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.DownloadedTransactionT = tBox.Object({
    ID: tBox.Number(),
    Batch: tBox.Number(),
    Incidental: tBox.Number(),
    Fee: tBox.Number(),
    FeeStart: (0, dates_1.DateObjT)(),
    FeeEnd: (0, dates_1.DateObjT)(),
    DescriptionKey: tBox.Number(),
    Date: (0, dates_1.DateObjT)(),
    Period: tBox.Number(),
    AccountType: tBox.Number(),
    Invoice: tBox.Number(),
    Resident: tBox.Number(),
    Account: tBox.Number(),
    BatchItem: tBox.Number(),
    Amount: tBox.Number(),
});
exports.BatchItemChequeInfoT = tBox.Object({
    ID: tBox.Number(),
    ChequeNumber: tBox.Number(),
    PaidBy: tBox.String(),
    PaidBSB: tBox.String(),
    BranchName: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.BatchItemT = tBox.Object({
    ID: tBox.Number(),
    Batch: tBox.Number(),
    Incidental: (0, meta_types_1.MaybeT)(tBox.Number()),
    Fee: (0, meta_types_1.MaybeT)(tBox.Number()),
    FeeStart: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    FeeEnd: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    DescriptionKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    ReferenceKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    BankKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    Date: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Quantity: tBox.Number(),
    ServiceCDC: (0, meta_types_1.MaybeT)(tBox.Number()),
    Added: (0, dates_1.DateTimeObjT)(),
    PaymentMethod: (0, meta_types_1.MaybeT)(tBox.Number()),
    PaymentChequeInfo: (0, meta_types_1.MaybeT)(exports.BatchItemChequeInfoT),
    Resident: tBox.Number(),
    Transactions: tBox.Array(exports.TransactionT),
});
exports.BatchT = tBox.Object({
    ID: tBox.Number(),
    Period: (0, meta_types_1.MaybeT)(tBox.Number()),
    Type: tBox.Number(),
    DescriptionKey: tBox.Number(),
    ChargeDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    IsFinalised: meta_types_1.tBoolT,
    TotalAmount: tBox.Number(),
    Incidental: (0, meta_types_1.MaybeT)(tBox.Number()),
    LegacyCode: (0, meta_types_1.MaybeT)(tBox.Number()),
    Template: (0, meta_types_1.MaybeT)(tBox.Number()),
    FacilityBank: (0, meta_types_1.MaybeT)(tBox.Number()),
    LastMod: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LastUser: (0, meta_types_1.MaybeT)(tBox.Number()),
    Size: tBox.Number(),
    Invoiced: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3), tBox.Literal(4)])),
    Items: tBox.Optional((0, meta_types_1.ModelTypeT)(exports.BatchItemT)),
});
exports.IncidentalT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String(),
    Name: tBox.String(),
    FullName: tBox.String(),
    GST: (0, meta_types_1.MaybeT)(tBox.Number()),
    Qualifier: (0, meta_types_1.MaybeT)(tBox.String()),
    GLCode: (0, meta_types_1.MaybeT)(tBox.String()),
    Color: tBox.String(),
    UnitPrice: (0, meta_types_1.MaybeT)(tBox.Number()),
    Active: meta_types_1.tBoolT,
    ServiceCategory: (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 1 })),
    ServiceID: (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 12 })),
});
exports.BedT = tBox.Object({
    ID: tBox.Number(),
    Wing: (0, meta_types_1.MaybeT)(tBox.String()),
    Room: (0, meta_types_1.MaybeT)(tBox.String()),
    Bed: (0, meta_types_1.MaybeT)(tBox.String()),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
    CurrentResident: (0, meta_types_1.MaybeT)(tBox.Number()),
    PublishedPrice: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.JournalAccountT = tBox.Object({
    ID: tBox.Number(),
    JournalAccountLocation: (0, meta_types_1.MaybeT)(tBox.String()),
    Source: (0, meta_types_1.MaybeT)(tBox.Number()),
    Name: tBox.String(),
    GST: tBox.String(),
    Credit: tBox.Number(),
    Account: (0, meta_types_1.MaybeT)(tBox.String()),
    Description: tBox.String(),
    Job: (0, meta_types_1.MaybeT)(tBox.String()),
    ItemType: tBox.String({ maxLength: 1 }),
});
exports.JournalAccountLocationT = tBox.Object({
    ID: tBox.Number(),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
    Name: tBox.String(),
});
exports.IgnoredAmountsPackedT = tBox.Object({
    Keys: tBox.Array(tBox.String()),
    Data: tBox.Array(tBox.Any()),
});
exports.IgnoredAmountT = tBox.Object({
    ID: tBox.Number(),
    Index: tBox.Number(),
    Fee: tBox.Number(),
    Account: tBox.Number(),
    DateStart: (0, dates_1.DateObjT)(),
    DateEnd: (0, dates_1.DateObjT)(),
    DailyAmount: tBox.Number(),
    IgnoredWhen: (0, dates_1.DateTimeObjT)(),
    IgnoredBy: tBox.String(),
    IgnoredReason: tBox.String(),
});
exports.InvoiceT = tBox.Object({
    ID: tBox.Number(),
    Period: tBox.Number(),
    Deleted: meta_types_1.tBoolT,
    Account: (0, meta_types_1.MaybeT)(tBox.Number()),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    FacilityImplied: (0, meta_types_1.MaybeT)(tBox.Number()),
    Type: (0, meta_types_1.MaybeT)(tBox.Number()),
    TotalGross: tBox.Number(),
    Created: (0, dates_1.DateTimeObjT)(),
    Count: tBox.Number(),
    Total: (0, meta_types_1.MaybeT)(tBox.Number()),
    MaxDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Batches: tBox.Array(tBox.Number()),
});
exports.EmailedInvoiceT = tBox.Object({
    Invoice: tBox.Number(),
    Contact: (0, meta_types_1.MaybeT)(tBox.Number()),
    Recipient: (0, meta_types_1.MaybeT)(tBox.String()),
    FileHash: (0, meta_types_1.MaybeT)(tBox.String()),
    Timestamp: (0, dates_1.DateTimeObjT)(),
    Delivered: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LogEmailID: (0, meta_types_1.MaybeT)(tBox.Number()),
    FacilityLevel: meta_types_1.tBoolT,
});
exports.ImportFileT = tBox.Object({
    ID: tBox.Number(),
    Filename: (0, meta_types_1.MaybeT)(tBox.String()),
    FileType: tBox.Number(),
    FileData: tBox.String(),
    Pages: (0, meta_types_1.MaybeT)(tBox.Array(tBox.Number())),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
    GPTLogKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    Created: (0, dates_1.DateTimeObjT)(),
    Completed: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.FeeValueT = tBox.Object({
    ID: tBox.Number(),
    Fee: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    Amount: (0, meta_types_1.MaybeT)(tBox.Number()),
    AmountType: (0, meta_types_1.MaybeT)(tBox.Number()),
    ESFCode: (0, meta_types_1.MaybeT)(tBox.String()),
    ILUFrequency: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.FeeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    DefaultAccountType: tBox.Number(),
    GST: (0, meta_types_1.MaybeT)(tBox.Number()),
    ESFType: (0, meta_types_1.MaybeT)(tBox.Number()),
    ILULocation: (0, meta_types_1.MaybeT)(tBox.Number()),
    HCType: (0, meta_types_1.MaybeT)(tBox.Number()),
    IsSubsidy: meta_types_1.tBoolT,
    IsSystem: meta_types_1.tBoolT,
    IsAccountable: meta_types_1.tBoolT,
    Values: tBox.Array(exports.FeeValueT),
});
exports.AmountTypeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    FeesPlus: tBox.Array(tBox.Number()),
    FeesMinus: tBox.Array(tBox.Number()),
});
exports.AccountTypeT = tBox.Object({
    ID: tBox.Number(),
    IsAdvance: meta_types_1.tBoolT,
    IsInvoiced: meta_types_1.tBoolT,
});
exports.MedicareFileT = tBox.Object({
    ID: tBox.Number(),
    Uploaded: (0, dates_1.DateTimeObjT)(),
    RACSNumber: tBox.Number(),
    Year: tBox.Number(),
    Month: tBox.Number(),
    FileHash: tBox.String(),
    MonthsAdjusted: tBox.Array(tBox.String()),
});
exports.MedicareModelCarePaymentMedicareT = tBox.Object({
    OriginalCode: tBox.String(),
    claimMonth: tBox.String(),
    effectiveDate: (0, dates_1.DateObjT)(),
    entitlementMonth: tBox.String(),
    paidCareDays: tBox.Number(),
    paidHospitalLeaveDays: tBox.Number(),
    paidSocialLeaveDays: tBox.Number(),
    paymentType: tBox.String(),
    ratePerDay: tBox.Number(),
    totalPayment: tBox.Number(),
});
exports.MedicareModelCareRecipientT = tBox.Object({
    accommodationPaymentStatus: tBox.String(),
    agedCareServiceClassificationCode: tBox.String(),
    basicResidentContribType: tBox.String(),
    careLevel: tBox.String(),
    careRecipientGivenName: tBox.String(),
    careRecipientID: tBox.Union([tBox.Number(), tBox.String()]),
    careRecipientSurname: tBox.String(),
    classificationExpiryDate: (0, dates_1.DateObjT)(),
    departureDate: (0, dates_1.DateObjT)(),
    entryDate: (0, dates_1.DateObjT)(),
    entryType: tBox.String(),
    pensionerType: tBox.String(),
    reappraisalDateInd: (0, dates_1.DateObjT)(),
    respiteCareDaysRemaining: tBox.Number(),
    socialLeaveDaysRemaining: tBox.Number(),
});
exports.MedicareModelRespiteAllocationT = tBox.Object({
    AllocationByMonth: tBox.Record(tBox.String(), tBox.Number()),
    Ratio: tBox.Number(),
    TotalAllocated: tBox.Number(),
    TotalUsed: tBox.Number(),
});
exports.MedicareModelSupportedRatioT = tBox.Object({
    Assisted: tBox.Number(),
    Supported: tBox.Number(),
    SupportedNew: tBox.Number(),
    SupportedPerc: tBox.Number(),
    SupportedPercNew: tBox.Number(),
    Total: tBox.Number(),
    TotalNew: tBox.Number(),
});
exports.BondT = tBox.Object({
    Account: tBox.Number(),
    Resident: tBox.Number(),
    AgreedDate: (0, dates_1.DateObjT)(),
    AgreedPrice: tBox.Number(),
    MonthlyRetention: tBox.Number(),
    MaxRetention: (0, meta_types_1.MaybeT)(tBox.Number()),
    RetentionEnd: (0, dates_1.DateObjT)(),
    ProbateTransferDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    RefundDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    InterestRate: tBox.Number(),
    PaymentMethodDesc: tBox.Number(),
    Comments: tBox.String(),
});
exports.MedicareModelConcreteT = tBox.Union([
    tBox.Literal(false),
    tBox.Object({
        isNewID: tBox.Boolean(),
        carePaymentsCalculated: (0, meta_types_1.ModelTypeT)(tBox.Record(tBox.Union([tBox.String(), tBox.Number()]), tBox.Record(tBox.Number(), tBox.Record(tBox.Number(), tBox.Number())))),
        carePaymentsMedicare: (0, meta_types_1.ModelTypeT)(tBox.Record(tBox.Union([tBox.String(), tBox.Number()]), tBox.Record(tBox.Number(), tBox.Record(tBox.Number(), exports.MedicareModelCarePaymentMedicareT)))),
        careRecipients: tBox.Object({
            calculated: tBox.Array(exports.MedicareModelCareRecipientT),
            medicare: tBox.Array(exports.MedicareModelCareRecipientT),
        }),
        respiteAllocation: exports.MedicareModelRespiteAllocationT,
        supportedRatio: tBox.Record(meta_types_1.tDateT, tBox.Object({
            calculated: exports.MedicareModelSupportedRatioT,
            medicare: exports.MedicareModelSupportedRatioT,
        })),
    }),
]);
exports.MedicareModelT = tBox.Record(tBox.String(), exports.MedicareModelConcreteT);
exports.RADMovementT = tBox.Object({
    ID: tBox.Number(),
    Account: tBox.Number(),
    AgreedDate: (0, dates_1.DateObjT)(),
    EndDate: (0, dates_1.DateObjT)(),
    IsRAC: meta_types_1.tBoolT,
    PublishedPrice: tBox.Number(),
    AgreedPrice: tBox.Number(),
    AgreedPayment: (0, meta_types_1.MaybeT)(tBox.Number()),
    AssetsTotal: (0, meta_types_1.MaybeT)(tBox.Number()),
    AssetsRetained: (0, meta_types_1.MaybeT)(tBox.Number()),
    ActualRAD: (0, meta_types_1.MaybeT)(tBox.Number()),
    InterestRate: tBox.Number(),
    PaymentMethodDesc: tBox.Number(),
    Comments: tBox.String(),
});
exports.RADT = tBox.Object({
    Account: tBox.Number(),
    Resident: tBox.Number(),
    ProbateTransferDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    DaysToRefund: tBox.Number(),
    RefundDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Movements: tBox.Array(exports.RADMovementT),
});
exports.BranchCustomT = tBox.Object({
    ID: tBox.Number(),
    BSB: tBox.String(),
    Name: tBox.String(),
    APCACode: tBox.String(),
});
exports.RACST = tBox.Object({
    ID: tBox.Number(),
    NAPSID: (0, meta_types_1.MaybeT)(tBox.String()),
    BPID: (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 10 })),
    TotalBeds: (0, meta_types_1.MaybeT)(tBox.Number()),
    TotalRespite: tBox.Number(),
    MajorRefurbishment: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    BasicSupplDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    BCTType: (0, meta_types_1.MaybeT)(tBox.Number()),
    OptInDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    AdjustedFee: meta_types_1.tBoolT,
    ExtraServices: meta_types_1.tBoolT,
});
exports.RACSRespiteAllocationT = tBox.Object({
    ID: tBox.Number(),
    RACS: tBox.Number(),
    EffectiveDate: (0, dates_1.DateObjT)(),
    RespiteAllocation: tBox.Number(),
});
exports.RACSViabilityCategoryT = tBox.Object({
    ID: tBox.Number(),
    RACS: tBox.Number(),
    EffectiveDate: (0, dates_1.DateObjT)(),
    Scheme: tBox.Number(),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
    TotalBeds: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.FacilityT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.Number(),
    Name: tBox.String(),
    FullName: tBox.String(),
    Type: tBox.String(),
    Address: (0, meta_types_1.MaybeT)(tBox.Number()),
    GSTCDC: (0, meta_types_1.MaybeT)(tBox.Number()),
    StatementHeaderImage: (0, meta_types_1.MaybeT)(tBox.String()),
    AgreementHeaderImg: (0, meta_types_1.MaybeT)(tBox.String()),
    GroupsInvoices: meta_types_1.tBoolT,
    IsMain: meta_types_1.tBoolT,
    EmailStatementSubject: tBox.String(),
    EmailStatementMessage: tBox.String(),
    EmailInvoiceSubject: tBox.String(),
    EmailInvoiceMessage: tBox.String(),
    RefundCommentCDC: tBox.String(),
});
exports.FacilityBankT = tBox.Object({
    ID: tBox.Number(),
    Facility: tBox.Number(),
    Bank: tBox.Number(),
    IsDefault: meta_types_1.tBoolT,
    SelfBalancing: meta_types_1.tBoolT,
    ABAUserID: tBox.String(),
    ABAFileDescription: tBox.String(),
    RemitterName: tBox.String(),
});
exports.FacilityContactT = tBox.Object({
    ID: tBox.Number(),
    Facility: tBox.Number(),
    Contact: tBox.Number(),
    Name: tBox.String(),
    IsPrimary: meta_types_1.tBoolT,
});
exports.FacilityStatementCommentT = tBox.Object({
    ID: tBox.Number(),
    Facility: tBox.Number(),
    Type: tBox.Number(),
    AccountType: tBox.Number(),
    Comment: tBox.String(),
});
exports.FacilityStatementLabelT = tBox.Object({
    Facility: tBox.Number(),
    AccountType: tBox.Number(),
    Type: tBox.Number(),
    Label: tBox.String(),
});
exports.FacilityLocationT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.Number(),
    Name: tBox.String(),
    FullCode: tBox.String(),
    FullName: tBox.String(),
    Facility: tBox.Number(),
    Type: tBox.String(),
    Address: (0, meta_types_1.MaybeT)(tBox.Number()),
    Contact: tBox.Number(),
    ABN: (0, meta_types_1.MaybeT)(tBox.String()),
    ACN: (0, meta_types_1.MaybeT)(tBox.String()),
    BedsAllocated: (0, meta_types_1.MaybeT)(tBox.Number()),
    RACSNumber: (0, meta_types_1.MaybeT)(tBox.Number()),
    RespiteAllocated: (0, meta_types_1.MaybeT)(tBox.Number()),
    Certified: meta_types_1.tBoolT,
    GLCode: (0, meta_types_1.MaybeT)(tBox.String()),
    BPayBillerCode: (0, meta_types_1.MaybeT)(tBox.String()),
    BPayCRNLength: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.BillingPeriodT = tBox.Object({
    ID: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, dates_1.DateObjT)(),
    IsClosed: meta_types_1.tBoolT,
    FeeChargesBatch: (0, meta_types_1.MaybeT)(tBox.Number()),
    FeeChargesAdjBatch: (0, meta_types_1.MaybeT)(tBox.Number()),
    TransferBatch: (0, meta_types_1.MaybeT)(tBox.Number()),
    ImportedInvoiceBatch: (0, meta_types_1.MaybeT)(tBox.Number()),
    HCIncidentalsBatch: (0, meta_types_1.MaybeT)(tBox.Number()),
    UsesTriOnline: meta_types_1.tBoolT,
});
exports.BillingPeriodFortnightlyT = tBox.Object({
    ID: tBox.Number(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Period: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.PeriodStepsT = tBox.Record(tBox.Number(), tBox.Record(tBox.Number(), (0, dates_1.DateTimeObjT)(), { description: "Key is 'step'" }), { description: "Key is 'period'" });
exports.PeriodStepCDCT = tBox.Object({
    ID: tBox.Number(),
    Period: tBox.Number(),
    Type: tBox.Number(),
    PayPeriod: tBox.Number(),
    Batch: (0, meta_types_1.MaybeT)(tBox.Number()),
    Timestamp: (0, dates_1.DateTimeObjT)(),
});
exports.PeriodStepsCDCT = tBox.Record(tBox.Number(), tBox.Array(exports.PeriodStepCDCT));
exports.RosterPeriodT = tBox.Object({
    ID: tBox.Number(),
    Start: (0, dates_1.DateObjT)(),
    End: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Run: tBox.Number(),
    PayPeriod: tBox.Number(),
    State: tBox.Number(),
});
exports.RosterClientGroupT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String(),
    Name: tBox.String(),
});
exports.HCIncidentalChargeT = tBox.Object({
    ID: tBox.Number(),
    Period: tBox.Number(),
    Resident: tBox.Number(),
    Date: (0, dates_1.DateObjT)(),
    Incidental: tBox.Number(),
    Amount: tBox.Number(),
    DescriptionKey: tBox.Number(),
    ReferenceKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    AccountTypeOverride: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CDCServiceT = tBox.Object({
    ID: tBox.Number(),
    Period: tBox.Number(),
    Client: tBox.Number(),
    ServiceType: tBox.Number(),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
    Date: (0, dates_1.DateObjT)(),
    Start: tBox.String(),
    Stop: tBox.String(),
    RosterKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Reimbursement: (0, meta_types_1.MaybeT)(tBox.Number()),
    TravelKM: (0, meta_types_1.MaybeT)(tBox.Number()),
    AccountType: (0, meta_types_1.MaybeT)(tBox.Number()),
    Facility: (0, meta_types_1.MaybeT)(tBox.Number()),
    IsCancelled: meta_types_1.tBoolT,
    ReferenceKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    DescriptionKeyOverride: (0, meta_types_1.MaybeT)(tBox.Number()),
    NDISCodeKey: (0, meta_types_1.MaybeT)(tBox.Number()),
    CostOverride: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CDCChargeCriteriaT = tBox.Object({
    ID: tBox.Number(),
    StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    AdmissionDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    ChargeGroup: (0, meta_types_1.MaybeT)(tBox.Number()),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
    LocationGroup: (0, meta_types_1.MaybeT)(tBox.Number()),
    DateTimeRange: (0, meta_types_1.MaybeT)(tBox.Number()),
    Sequence: (0, meta_types_1.MaybeT)(tBox.Number()),
    FixedRate: (0, meta_types_1.MaybeT)(tBox.Number()),
    HourlyRate: (0, meta_types_1.MaybeT)(tBox.Number()),
    MinCharge: (0, meta_types_1.MaybeT)(tBox.Number()),
    MaxCharge: (0, meta_types_1.MaybeT)(tBox.Number()),
    KmCharge: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CDCChargeGroupT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    GST: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CDCChargeSequenceT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    MinHours: (0, meta_types_1.MaybeT)(tBox.String()),
    MaxHours: (0, meta_types_1.MaybeT)(tBox.String()),
    MinInclusive: meta_types_1.tBoolT,
    MaxInclusive: meta_types_1.tBoolT,
});
exports.CDCDateTimeRangeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Mon: meta_types_1.tBoolT,
    Tue: meta_types_1.tBoolT,
    Wed: meta_types_1.tBoolT,
    Thu: meta_types_1.tBoolT,
    Fri: meta_types_1.tBoolT,
    Sat: meta_types_1.tBoolT,
    Sun: meta_types_1.tBoolT,
    PubHol: meta_types_1.tBoolT,
    Start: (0, meta_types_1.MaybeT)(tBox.String()),
    Finish: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.CDCServiceTypeT = tBox.Object({
    ID: tBox.Number(),
    Active: meta_types_1.tBoolT,
    Code: tBox.String(),
    Name: tBox.String(),
    ChargeGroup: tBox.Number(),
    ServiceCategory: (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 1 })),
    ServiceID: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.CDCLocationGroupT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Locations: tBox.Array(tBox.Number()),
});
exports.CDCAccountRuleT = tBox.Object({
    ID: tBox.Number(),
    Location: (0, meta_types_1.MaybeT)(tBox.Number()),
    ServiceType: (0, meta_types_1.MaybeT)(tBox.Number()),
    Client: (0, meta_types_1.MaybeT)(tBox.Number()),
    AccountType: tBox.Number(),
});
exports.DDExemptT = tBox.Object({
    ID: tBox.Number(),
    Resident: (0, meta_types_1.MaybeT)(tBox.Number()),
    Fee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Incidental: (0, meta_types_1.MaybeT)(tBox.Number()),
    DateStart: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    DateEnd: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.BillingMetaT = tBox.Object({
    Facility: tBox.Number(),
    SubFacility: tBox.Number(),
    IsCDC: meta_types_1.tBoolT,
    User: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.BankT = tBox.Object({
    ID: tBox.Number(),
    BSB: tBox.String(),
    Account: tBox.String(),
    Name: (0, meta_types_1.MaybeT)(tBox.String()),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.BillingSystemValuesT = tBox.Object({
    AgreementsSchema: tBox.Number(),
    ApplyGSTServiceTravel: meta_types_1.tBoolT,
    BillingStart: (0, dates_1.DateObjT)(),
    DefaultReceivesInvoices: meta_types_1.tBoolT,
    FlipSignCDCStatements: meta_types_1.tBoolT,
    Frequency: tBox.Number(),
    IsCDC: meta_types_1.tBoolT,
    LastRecalc: (0, dates_1.DateTimeObjT)(),
    PostMigration: meta_types_1.tBoolT,
    SchemaDate: (0, dates_1.DateObjT)(),
    ShowAbsValStatements: meta_types_1.tBoolT,
    ShowPeriodStmtDate: tBox.Number(),
    SplitCDCChargeBlocks: meta_types_1.tBoolT,
    TriOnlineStart: (0, dates_1.DateObjT)(),
    TriOnlineStartDAP: (0, dates_1.DateObjT)(),
    EnableAgreements: tBox.Union([tBox.Literal(-1), tBox.Literal(1)]),
    EnforceAgreements: tBox.Union([(0, dates_1.DateObjT)(), tBox.Literal('')]),
    StatementInvoiceNumbers: meta_types_1.tBoolT,
});
exports.AccountTypeStaticT = tBox.Object({
    ID: tBox.Number(),
    ShortName: tBox.String(),
    Name: tBox.String(),
    AvailableResidential: meta_types_1.tBoolT,
    AvailableCDC: meta_types_1.tBoolT,
});
exports.staticIDNameT = (0, meta_types_1.ModelTypeT)(tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
}));
exports.staticCodeNameT = (0, meta_types_1.ModelStrT)(tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
}));
exports.staticIDCodeNameT = (0, meta_types_1.ModelTypeT)(tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String(),
    Name: tBox.String(),
}));
exports.staticANACCClassT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: tBox.String(),
    IsRespite: meta_types_1.tBoolT,
    IsDefault: meta_types_1.tBoolT,
    VariableRate: (0, meta_types_1.MaybeT)(tBox.Number()),
    MinutesCare: (0, meta_types_1.MaybeT)(tBox.Number()),
    MinutesRN: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticBankBranchT = tBox.Object({
    BSB: tBox.String(),
    Name: tBox.String(),
    Bank: tBox.Number(),
});
exports.staticBRCTypeT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String(),
    Name: tBox.String(),
    FeeID: (0, meta_types_1.MaybeT)(tBox.Number()),
    FeeIDCleanEnergy: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticBCTTypeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Subsidy: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticDischargeReasonT = tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
    MedicareCodeCDC: (0, meta_types_1.MaybeT)(tBox.Number()),
    MedicareCodeResidential: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticILUFeeFrequencyT = tBox.Object({
    ID: tBox.String(),
    Name: tBox.String(),
    Days: tBox.Number(),
});
exports.staticImportFileTypeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    MimeType: tBox.String(),
});
exports.staticLeaveReasonT = tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
    AvailableCDC: meta_types_1.tBoolT,
    AvailableResidential: meta_types_1.tBoolT,
});
exports.staticNoteTypeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: tBox.String(),
});
exports.staticRespiteTypeT = tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
    NameShort: tBox.String(),
});
exports.staticInterestAndAssetsT = tBox.Object({
    ID: tBox.Number(),
    Date: (0, dates_1.DateObjT)(),
    MaximumRate: (0, meta_types_1.MaybeT)(tBox.Number()),
    BasicRate: (0, meta_types_1.MaybeT)(tBox.Number()),
    MinAssetsRetained: (0, meta_types_1.MaybeT)(tBox.Number()),
    MaxAssetsAssisted: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticSalutationT = tBox.Object({
    Title: tBox.String(),
    FullTitle: (0, meta_types_1.MaybeT)(tBox.String()),
    Frequency: (0, meta_types_1.MaybeT)(tBox.Number()),
    Gender: (0, meta_types_1.MaybeT)(tBox.String()),
    GenderAlt: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.staticHCServiceCategoryT = tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
    LowerPercentageFeeValue: tBox.Number(),
    UpperPercentageFeeValue: tBox.Number(),
    LowerPercentageFeeValueGrandfathered: tBox.Number(),
    UpperPercentageFeeValueGrandfathered: tBox.Number(),
});
exports.staticHCPackageLevelsT = tBox.Object({
    Code: tBox.String(),
    Name: tBox.String(),
    SubsidyID: (0, meta_types_1.MaybeT)(tBox.Number()),
    DementiaSupplementID: (0, meta_types_1.MaybeT)(tBox.Number()),
    VeteranSupplementID: (0, meta_types_1.MaybeT)(tBox.Number()),
    DailyFeeID: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.staticProdaServicesT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String(),
    Name: tBox.String(),
    ServiceGroup: tBox.Number(),
    ServiceType: tBox.Number(),
});
exports.BillingStaticT = tBox.Object({
    accommodationPayments: exports.staticCodeNameT,
    accountTypes: (0, meta_types_1.ModelTypeT)(exports.AccountTypeStaticT),
    acfiCategories: exports.staticCodeNameT,
    anaccClasses: (0, meta_types_1.ModelTypeT)(exports.staticANACCClassT),
    bankBranches: (0, meta_types_1.ModelStrT)(exports.staticBankBranchT),
    banks: exports.staticIDCodeNameT,
    batchTypes: exports.staticIDCodeNameT,
    brcTypes: (0, meta_types_1.ModelTypeT)(exports.staticBRCTypeT),
    bctTypes: (0, meta_types_1.ModelTypeT)(exports.staticBCTTypeT),
    concessionTypes: exports.staticIDCodeNameT,
    contactTypes: exports.staticIDNameT,
    dischargeReasons: (0, meta_types_1.ModelStrT)(exports.staticDischargeReasonT),
    drawdownMethods: exports.staticIDNameT,
    enteralTypes: exports.staticCodeNameT,
    esfTypes: exports.staticIDNameT,
    facilityTypes: exports.staticCodeNameT,
    feeTypes: exports.staticIDNameT,
    genders: exports.staticCodeNameT,
    gstTypes: exports.staticIDNameT,
    hcFeeTypes: exports.staticIDNameT,
    hcServiceCategories: (0, meta_types_1.ModelStrT)(exports.staticHCServiceCategoryT),
    hcSubsidyLevels: (0, meta_types_1.ModelStrT)(exports.staticHCPackageLevelsT),
    iluFeeFrequencies: (0, meta_types_1.ModelStrT)(exports.staticILUFeeFrequencyT),
    importFileTypes: (0, meta_types_1.ModelTypeT)(exports.staticImportFileTypeT),
    incidentalQualifiers: exports.staticCodeNameT,
    interestAndAssets: (0, meta_types_1.ModelTypeT)(exports.staticInterestAndAssetsT),
    leaveReasons: (0, meta_types_1.ModelStrT)(exports.staticLeaveReasonT),
    liabilities: exports.staticCodeNameT,
    locationTypes: exports.staticCodeNameT,
    maritalStatuses: exports.staticCodeNameT,
    mmmCategories: exports.staticIDNameT,
    noteTypes: (0, meta_types_1.ModelTypeT)(exports.staticNoteTypeT),
    paymentMethodsBond: exports.staticIDNameT,
    paymentMethodsRAD: exports.staticIDNameT,
    paymentMethodsReceipt: exports.staticIDNameT,
    pensionStatuses: exports.staticCodeNameT,
    periodSteps: exports.staticIDNameT,
    postCodes: (0, meta_types_1.ModelTypeT)(meta_types_1.PostCodeT),
    providers: exports.staticCodeNameT,
    rcsCategories: exports.staticCodeNameT,
    respiteTypes: (0, meta_types_1.ModelStrT)(exports.staticRespiteTypeT),
    salutations: (0, meta_types_1.ModelStrT)(exports.staticSalutationT),
    statementCommentTypes: exports.staticIDNameT,
    states: exports.staticCodeNameT,
    viabilityLocationTypes: exports.staticIDNameT,
    prodaServices: (0, meta_types_1.ModelTypeT)(exports.staticProdaServicesT),
});
exports.TaskListItemT = tBox.Object({
    ID: tBox.String(),
    Status: types_agents_1.TaskStatusT,
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    UpdatedAt: (0, dates_1.DateTimeObjT)(),
    Facility: tBox.Number(),
    SubFacility: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApplicationType: tBox.String(),
    AllowAgents: meta_types_1.tBoolT,
});
exports.TaskDetailsT = tBox.Object({
    task: types_agents_1.TaskT,
    checklistItems: tBox.Array(types_agents_1.TaskChecklistItemT),
    attachments: tBox.Array(types_agents_1.TaskAttachmentT),
    discussionItems: tBox.Array(types_agents_1.DiscussionItemT),
});
exports.TaskThreadsByTaskT = tBox.Record(tBox.String(), tBox.Array(types_llm_2_1.AgentThreadT));
exports.AgentMetaT = tBox.Object({
    skills: tBox.Array(types_agents_1.SkillT),
    emailReceivers: tBox.Array(types_agents_1.EmailReceiverT),
    emailAllowlist: tBox.Array(types_agents_1.EmailAllowlistEntryT),
});
exports.BillingDataModelT = tBox.Object({
    residents: (0, meta_types_1.ModelTypeT)(exports.ResidentT),
    residentsInWaiting: (0, meta_types_1.ModelTypeT)(exports.ResidentInWaitingT),
    residentAccounts: (0, meta_types_1.ModelTypeT)(exports.ResidentAccountT),
    residentAdmissions: (0, meta_types_1.ModelTypeT)(exports.ResidentAdmissionT),
    residentBanks: (0, meta_types_1.ModelTypeT)(exports.ResidentBankT),
    residentContacts: (0, meta_types_1.ModelTypeT)(exports.ResidentContactT),
    residentLeave: (0, meta_types_1.ModelTypeT)(exports.ResidentLeaveT),
    residentNotes: (0, meta_types_1.ModelTypeT)(exports.ResidentNoteT),
    statementsEmailed: tBox.Array(exports.EmailedStatementT),
    homecareBudgets: (0, meta_types_1.ModelTypeT)(exports.HomeCareBudgetT),
    historicalMTF: exports.HistoricalMTFNodeT,
    movements: (0, meta_types_1.ModelTypeT)(exports.MovementT),
    batches: (0, meta_types_1.ModelTypeT)(exports.BatchT),
    incidentals: (0, meta_types_1.ModelTypeT)(exports.IncidentalT),
    ghosted: tBox.Union([exports.IgnoredAmountsPackedT, tBox.Array(exports.IgnoredAmountT)]),
    invoices: (0, meta_types_1.ModelTypeT)(exports.InvoiceT),
    invoicesEmailed: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.EmailedInvoiceT)),
    importFiles: (0, meta_types_1.ModelTypeT)(exports.ImportFileT),
    accomBonds: (0, meta_types_1.ModelTypeT)(exports.BondT),
    accomRads: (0, meta_types_1.ModelTypeT)(exports.RADT),
    residentAgreementsStatus: (0, meta_types_1.ModelTypeT)(exports.ResidentAgreementStatusT),
    fees: (0, meta_types_1.ModelTypeT)(exports.FeeT),
    amountTypes: (0, meta_types_1.ModelTypeT)(exports.AmountTypeT),
    accountTypes: (0, meta_types_1.ModelTypeT)(exports.AccountTypeT),
    medicareFiles: tBox.Record(tBox.Number(), tBox.Record(tBox.String(), exports.MedicareFileT, {
        description: "Key is 'monthyear'",
    }), { description: "Key is 'racs'" }),
    medicareModels: (0, meta_types_1.ModelStrT)(exports.MedicareModelT),
    bankBranchesCustom: (0, meta_types_1.ModelTypeT)(exports.BranchCustomT),
    racsIDs: (0, meta_types_1.ModelTypeT)(exports.RACST),
    racsRespiteAllocation: tBox.Record(tBox.Number(), tBox.Array(exports.RACSRespiteAllocationT), { description: "Key is 'racs'" }),
    racsViabilityCategories: tBox.Record(tBox.Number(), tBox.Array(exports.RACSViabilityCategoryT), { description: "Key is 'racs'" }),
    facilities: (0, meta_types_1.ModelTypeT)(exports.FacilityT),
    facilityBanks: (0, meta_types_1.ModelTypeT)(exports.FacilityBankT),
    facilityContacts: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.FacilityContactT)),
    facilityStatementComments: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.FacilityStatementCommentT)),
    facilityStatementLabels: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.FacilityStatementLabelT)),
    journalAccounts: (0, meta_types_1.ModelTypeT)(exports.JournalAccountT),
    journalAccountLocations: (0, meta_types_1.ModelTypeT)(exports.JournalAccountLocationT),
    locations: (0, meta_types_1.ModelTypeT)(exports.FacilityLocationT),
    period: tBox.Number(),
    periods: (0, meta_types_1.ModelTypeT)(exports.BillingPeriodT),
    periodsFortnightly: (0, meta_types_1.ModelTypeT)(exports.BillingPeriodFortnightlyT),
    periodSteps: exports.PeriodStepsT,
    periodStepsCDC: exports.PeriodStepsCDCT,
    rosterPeriods: (0, meta_types_1.ModelTypeT)(exports.RosterPeriodT),
    rosterClientGroups: (0, meta_types_1.ModelTypeT)(exports.RosterClientGroupT),
    reportJobs: (0, meta_types_1.ModelTypeT)(types_reports_1.ReportJobT),
    cdcServices: (0, meta_types_1.ModelTypeT)(exports.CDCServiceT),
    hcIncidentalCharges: (0, meta_types_1.ModelTypeT)(exports.HCIncidentalChargeT),
    cdcChargeCriterias: (0, meta_types_1.ModelTypeT)(exports.CDCChargeCriteriaT),
    cdcChargeGroups: (0, meta_types_1.ModelTypeT)(exports.CDCChargeGroupT),
    cdcChargeSequences: (0, meta_types_1.ModelTypeT)(exports.CDCChargeSequenceT),
    cdcDateTimeRanges: (0, meta_types_1.ModelTypeT)(exports.CDCDateTimeRangeT),
    cdcServiceTypes: (0, meta_types_1.ModelTypeT)(exports.CDCServiceTypeT),
    cdcLocationGroups: (0, meta_types_1.ModelTypeT)(exports.CDCLocationGroupT),
    cdcAccountRules: tBox.Array(exports.CDCAccountRuleT),
    ddExempt: (0, meta_types_1.ModelTypeT)(exports.DDExemptT),
    meta: exports.BillingMetaT,
    static: tBox.Optional(exports.BillingStaticT),
    staticHash: (0, dates_1.DateTimeObjT)(),
    addresses: (0, meta_types_1.ModelTypeT)(meta_types_1.AddressCardT),
    contacts: (0, meta_types_1.ModelTypeT)(meta_types_1.ContactCardT),
    banks: (0, meta_types_1.ModelTypeT)(exports.BankT),
    descs: tBox.Record(tBox.Number(), tBox.String()),
    beds: (0, meta_types_1.ModelTypeT)(exports.BedT),
    sysvals: exports.BillingSystemValuesT,
    changeLog: tBox.Record(meta_types_1.tDateT, tBox.Number()),
    facilityID: tBox.Number(),
    subFacilityID: tBox.Number(),
    timers: tBox.Record(tBox.String(), tBox.Number()),
    _cachedAccountTransactions: tBox.Optional((0, meta_types_1.ModelTypeT)(tBox.Array(tBox.Any()))),
    batchItems: tBox.Optional((0, meta_types_1.ModelTypeT)(exports.BatchItemT)),
    transactions: tBox.Optional(tBox.Array(exports.TransactionT)),
    tasks: tBox.Array(exports.TaskListItemT),
    taskDetails: tBox.Record(tBox.String(), exports.TaskDetailsT),
    taskThreads: exports.TaskThreadsByTaskT,
    rawAgentThreads: tBox.Record(tBox.String(), types_llm_2_1.AgentThreadT),
    agentMeta: exports.AgentMetaT,
    agentThreads: tBox.Record(tBox.String(), types_llm_2_1.AgentThreadSummaryT),
    agentThreadContent: tBox.Record(tBox.String(), types_llm_2_1.AgentThreadContentT),
});
exports.BatchPackageT = tBox.Object({
    Batches: tBox.Record(tBox.Number(), exports.BatchT),
    Descs: tBox.Record(tBox.Number(), tBox.String()),
});
exports.HydrationNodeT = tBox.KeyOf(tBox.Omit(exports.BillingDataModelT, [
    'timers',
    'facilityID',
    'subFacilityID',
    '_cachedAccountTransactions',
    'batchItems',
    'transactions',
]));
const hydrationNodes = (...nodes) => [...nodes];
exports.hydrationNodes = hydrationNodes;
var HydrationActionType;
(function (HydrationActionType) {
    HydrationActionType["RunAdjustments"] = "runAdjustments";
})(HydrationActionType || (exports.HydrationActionType = HydrationActionType = {}));
exports.HydrationSpecItemT = tBox.Partial(tBox.Object({
    nodes: (0, meta_types_1.MaybeT)(tBox.Array(exports.HydrationNodeT)),
    agentThreadContentIDs: (0, meta_types_1.MaybeT)(tBox.Array(tBox.String())),
    batchIDs: (0, meta_types_1.MaybeT)(tBox.Array(tBox.Number())),
    descIDs: (0, meta_types_1.MaybeT)(tBox.Array((0, meta_types_1.MaybeT)(tBox.Number()))),
    descTexts: (0, meta_types_1.MaybeT)(tBox.Array(tBox.String())),
    actions: (0, meta_types_1.MaybeT)(tBox.Array(tBox.Object({
        type: tBox.Literal(HydrationActionType.RunAdjustments),
        residents: tBox.Array(tBox.Number()),
    }))),
}, { additionalProperties: false }));
exports.HydrationSpecT = tBox.Union([
    tBox.Union([exports.HydrationSpecItemT, tBox.Null()]),
    tBox.Array(tBox.Union([exports.HydrationSpecItemT, tBox.Null()])),
]);
const agentThreadHydration = (threadIDs, nodes = (0, exports.hydrationNodes)('agentThreads')) => ({
    nodes,
    agentThreadContentIDs: threadIDs,
});
exports.agentThreadHydration = agentThreadHydration;
exports.HydrationPayloadT = tBox.Object({
    newData: tBox.Optional(tBox.Record(tBox.String(), tBox.Unknown())),
    batchData: tBox.Optional(exports.BatchPackageT),
    descs: tBox.Optional(tBox.Record(tBox.String(), tBox.String())),
});
exports.BillingErrorT = tBox.Object({
    Text: tBox.String(),
});
exports.ErrorItemT = tBox.Object({
    Name: tBox.String(),
    Weight: tBox.Number(),
    Errors: tBox.Array(exports.BillingErrorT),
});
exports.ErrorsListT = tBox.Record(tBox.String(), exports.ErrorItemT);
//# sourceMappingURL=types-billing.js.map